import PropTypes from 'prop-types';

const PaymentProfileType = PropTypes.shape({
  id: PropTypes.string,
  user_id: PropTypes.string,
  name: PropTypes.string,
  payment_method: PropTypes.string,
  payment_verification: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    gateway_action: PropTypes.object
  }),
  autopay_enabled: PropTypes.bool,
  autopay: PropTypes.bool,
  test_mode: PropTypes.bool
});

export default PaymentProfileType;
